/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

module.exports = function(formData) {
  var deferred = $.Deferred();
  $.soap({
    body: {
      SubmitContact: {
        $xmlns: 'http://dobs.pa.gov/co/contact/bpm/1.0',
        ContactID: formData.contactId,
        FirstName: formData.firstName,
        LastName: formData.lastName,
        Email: formData.email,
        Phone: formData.phone,
        Notes: formData.notes
      }
    },
    blueprint: {
      contactId: '$..ContactID.__text',
      firstName: '$..FirstName.__text',
      lastName: '$..LastName.__text',
      email: '$..Email.__text',
      phone: '$..Phone.__text',
      notes: '$..Notes.__text'
    }
  })
    .done(function(response) {
      response.name = response.firstName + ' ' + response.lastName;
      deferred.resolve(response);
    })
    .fail(function() {
      deferred.reject();
    });

  return deferred.promise();
};
